var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.appOnClick,"input":_vm.appOnInput}},[(_vm.loggedIn)?_c('NavigationBar'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[(_vm.loggedIn)?_c('SideBar'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column",attrs:{"id":"content-wrapper"}},[_c('router-view')],1)],1),_vm._v(" "),_c('SystemToasts')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec3b112e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 